// extracted by mini-css-extract-plugin
module.exports = {"signup":"Signup-module--signup--2Pia6"};